module.exports = __webpack_public_path__ + "media/images/official/voice_masuda-1a91ed12bbc22816f08c3593c5ebb876.png";